// Layout principal que integra Sidebar e BottomHeader
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { BottomHeader } from './BottomHeader';
import { CardEmpresa } from './CardEmpresa';

export function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 dark:bg-gray-950">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Card da Empresa - Fora da Sidebar mas posicionado no mesmo lugar */}
      <div className="fixed bottom-0 left-0 w-64 z-[60] hidden lg:block">
        <CardEmpresa />
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden ml-0 lg:ml-64 w-full">
        {/* Page Content - Área principal vai até o topo */}
        <main className="flex-1 overflow-y-auto custom-scrollbar p-4 md:p-6 w-full pb-20">
          <Outlet />
        </main>

        {/* Bottom Header - Sticky na parte inferior */}
        <BottomHeader onMenuClick={() => setSidebarOpen(true)} />
      </div>
    </div>
  );
}
